import React, { Fragment } from 'react'
import * as styles from './Containers.module.scss'

const SectionContainer = ({
  id,
  topBorder = false,
  btmBorder = false,
  color,
  type,
  children,
  classes = null,
}) => {
  // color: navy, dark navy, white, gray
  //type: fullWidth, contained
  return (
    <Fragment>
      {type === 'fullWidth' && (
        <article
          id={id}
          className={` 
                    ${styles[`${color}`]}
                    ${styles[`${type}`]} 
                    ${topBorder && styles[`topBorder`]}
                    ${btmBorder && styles[`btmBorder`]}  
                    `}
        >
          <article
            className={`${styles.contentWrap} ${
              classes ? classes.join(' ') : ''
            }`}
          >
            {children}
          </article>
        </article>
      )}
      {type === 'contained' && (
        <article className={styles.containerWrap}>
          <article
            id={id}
            className={` 
                    ${styles[`${color}`]}
                    ${styles[`${type}`]} 
                    ${classes ? classes.join(' ') : ''}`}
          >
            {children}
          </article>
        </article>
      )}
      {type !== 'fullWidth' && type !== 'contained' && (
        <article
          id={id}
          className={` 
                    ${styles[`${color}`]}
                    ${styles[`${type}`]} 
                    ${classes ? classes.join(' ') : ''}`}
        >
          {children}
        </article>
      )}
    </Fragment>
  )
}

export default SectionContainer
